import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig, motion } from "framer-motion";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollManager, SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import NotFound from "@/pages/NotFound";

const Page = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <motion.main key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
      {children}
    </motion.main>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Navbar />
        <Page>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Page>
        <Footer />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111111", border: "1px solid #252525", color: "#F2EFE8", borderRadius: 0 } }} />
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
